import classNames from 'classnames';
import React, { MouseEventHandler, VFC } from 'react';
import { ChevronDownStrongIcon } from 'src/monet/icons';
import { Nullable } from 'src/types/nullable.type';
import { functionNoop } from 'src/utils/function/noop';
import { Button, ButtonProps } from './button';

export interface ButtonWithMenuProps extends Omit<ButtonProps, 'onClick' | 'variant' | 'size' | 'className'> {
  disabled?: boolean;
  variant: Omit<ButtonProps['variant'], 'tertiary'>;
  onMenuClick?: MouseEventHandler;
  onButtonClick?: MouseEventHandler;
  renderMenu: (menuButton: JSX.Element) => Nullable<JSX.Element>;
  containerClassName?: string;
  menuButtonClassName?: string;
  buttonClassName?: string;
}

export const ButtonWithMenu: VFC<ButtonWithMenuProps> = ({
  disabled = false,
  onMenuClick = functionNoop,
  onButtonClick = functionNoop,
  renderMenu,
  label,
  variant,
  buttonClassName,
  menuButtonClassName,
  containerClassName,
}) => {
  const isPrimaryVariant = variant === 'primary';

  return (
    <div className={classNames('flex relative rounded-lg', containerClassName)}>
      <Button
        label={label}
        className={classNames('rounded-r-none border-r-0', buttonClassName)}
        size='regular'
        variant={variant as ButtonProps['variant']}
        onClick={onButtonClick}
        disabled={disabled}
      />
      <div className='absolute right-9 w-px h-full z-10'>
        <div
          className={classNames('w-full h-full', {
            'btn-primary-divider': isPrimaryVariant,
            'bg-bedrock-gray-medium': !isPrimaryVariant,
          })}
        />
      </div>
      {renderMenu(
        <Button
          size='regular'
          className={classNames('rounded-l-none border-l-0 p-0 h-10 -mr-0.5', menuButtonClassName)}
          variant={variant as ButtonProps['variant']}
          onClick={onMenuClick}
          disabled={disabled}
          icon={
            <div className='px-2 py-2.5'>
              <ChevronDownStrongIcon className={`${isPrimaryVariant ? 'text-bedrock-white' : 'text-bedrock-black'}`} />
            </div>
          }
        />
      )}
    </div>
  );
};
